const jobOffers = (() => {
  let container;
  let list;
  let errorWrapper;
  let perPage;
  let currentPage = 1;

  const init = () => {
    container = document.querySelector('[data-job-offers]');
    if (!container) return;

    list = container.querySelector('ul');
    errorWrapper = container.querySelector('[data-job-error]');
    perPage = parseInt(container.dataset.perPage, 10) || 10;

    loadPage(1);
  };

  const loadPage = (page) => {
    showSkeleton();

    const ajaxUrl = window.themeConfig?.ajaxUrl || '/wp-admin/admin-ajax.php';

    fetch(`${ajaxUrl}?action=get_job_offers&page=${page}&per_page=${perPage}`)
      .then((r) => r.json())
      .then((data) => {
        currentPage = data.page;
        renderJobs(data.jobs);
        if (container.hasAttribute('data-paginate')) {
          renderPagination(data);
        }
      })
      .catch(() => {
        list.innerHTML = '';
        if (errorWrapper) errorWrapper.innerHTML = '<p>Nie udało się pobrać ofert pracy.</p>';
      });
  };

  const showSkeleton = () => {
    var skeletonItem =
      '<li class="columns skeleton"><div class="job-card">' +
      '<span class="job-name"></span>' +
      '<h3 class="h4 job-title"></h3>' +
      '<span class="job-location"></span>' +
      '</div></li>';
    list.innerHTML = new Array(perPage).fill(skeletonItem).join('');
  };

  const renderJobs = (jobs) => {
    if (!jobs.length) {
      list.innerHTML = '';
      if (errorWrapper) errorWrapper.innerHTML = '<p>Brak ogłoszeń.</p>';
      return;
    }

    list.innerHTML = jobs
      .map(
        (job) => `
      <li>
        <a class="job-card" href="${job.url}" target="_blank" rel="nofollow noopener">
          ${job.department ? `<span class="job-name">${job.department}</span>` : ''}
          <h3 class="h4 job-title">${job.title}</h3>
          <span class="job-location">${job.location}</span>
          <span class="button button-secondary">Aplikuj</span>
        </a>
      </li>
    `,
      )
      .join('');
  };

  const renderPagination = ({ page, pages }) => {
    let pagination = container.querySelector('[data-job-pagination]');

    if (pages <= 1) {
      if (pagination) pagination.remove();
      return;
    }

    if (!pagination) {
      pagination = document.createElement('div');
      pagination.setAttribute('data-job-pagination', '');
      pagination.className = 'job-pagination';
      container.appendChild(pagination);
    }

    pagination.innerHTML = `
      <button class="job-pagination__btn job-pagination__prev" ${page <= 1 ? 'disabled' : ''} aria-label="Poprzednia strona">&#8592;</button>
      <span class="job-pagination__info">Strona ${page} z ${pages}</span>
      <button class="job-pagination__btn job-pagination__next" ${page >= pages ? 'disabled' : ''} aria-label="Następna strona">&#8594;</button>
    `;

    pagination.querySelector('.job-pagination__prev').addEventListener('click', () => {
      loadPage(currentPage - 1);
      container.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    pagination.querySelector('.job-pagination__next').addEventListener('click', () => {
      loadPage(currentPage + 1);
      container.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  };

  return { init };
})();

export { jobOffers };
